export default __webpack_public_path__ + "40ca49e3e4d3251c598434b1b5696117.png";